var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h1',{staticClass:"title"},[_vm._v("Review")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('icons-to-review-list'),_vm._v(" "),_c('br'),_vm._v(" "),_c('apps-to-check')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }